import React from 'react'
import { withApp } from '@brainstud/react-tbl/themes/pgw/v1/helpers'

class Modal extends React.Component {
  componentDidMount() {
    document.querySelector('html').classList.add('hide-scroll')
  }

  componentWillUnmount() {
    document.querySelector('html').classList.remove('hide-scroll')
  }

  render() {
    if (this.props.app.modal !== this.props.name) return null

    const Component = this.props.component
    return <Component {...this.props} data={this.props.app.modalData} />
  }
}

class ModalSwitch extends React.Component {
  render() {
    let modal = null

    React.Children.forEach(this.props.children, child => {
      if (child.props.name === this.props.app.modal) {
        modal = child
      }
    })

    return modal
  }
}

const ModalSwitchWithApp = withApp(ModalSwitch)

export default withApp(Modal)
export { ModalSwitchWithApp as ModalSwitch }